import type { Route } from '~/core/router'

import * as partnerProgram from '~/routes/partner-program/grid'

export const route: Route = {
  children: [
    {
      path: '',
      component: [partnerProgram.PartnerProgramGridPage],
      init: partnerProgram.model.init,
      left: partnerProgram.model.left,
    },
  ],
}
